export default __webpack_public_path__ + "static/media/US_Hero7_1.6ede73fd.png";